import { render, staticRenderFns } from "./DetailData.vue?vue&type=template&id=570b7905"
import script from "./DetailData.vue?vue&type=script&lang=ts"
export * from "./DetailData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports